import { EntityRole } from './apollo/graphqlSchema';

export const entityRolesLabels: Record<EntityRole, string> = {
  [EntityRole.Owner]: 'Creator',
  [EntityRole.Manager]: 'Manager',
  [EntityRole.Editor]: 'Editor',
  [EntityRole.Viewer]: 'Viewer',
};
